import React, { useEffect, useState } from 'react'
import RemoteSvgWithJS from './RemoteSvgWithJS.jsx'
import RemoteSvgWithCSS from './RemoteSvgWithCSS.jsx'

const RemoteSvg = ({
  url = '',
  alignment = 'center',
  classNames = '',
  ...props
}) => {
  const [svgContent, setSvgContent] = useState(null)

  const alignmentClass = `u-flex u-flexCol ${alignment === 'left' ? 'u-flexAlignItemsStart' : alignment === 'right' ? 'u-flexAlignItemsEnd' : 'u-flexAlignItemsCenter'}`

  useEffect(() => {
    if (!url) return
    fetch(url)
      .then((res) => res.text())
      .then(setSvgContent)
  }, [url])

  return (
    <>
      {svgContent && svgContent.indexOf('<svg') !== -1 ? (
        svgContent.indexOf('<script>') !== -1 ? (
          <RemoteSvgWithJS
            url={url}
            svgContent={svgContent}
            classNames={`${classNames} ${alignmentClass}`}
            {...props}
          />
        ) : (
          <RemoteSvgWithCSS
            url={url}
            svgContent={svgContent}
            classNames={`${classNames} ${alignmentClass}`}
            {...props}
          />
        )
      ) : null}
    </>
  )
}

export default RemoteSvg
